import { render, staticRenderFns } from "./HeadSearch.vue?vue&type=template&id=03543fa4&scoped=true&"
import script from "./HeadSearch.vue?vue&type=script&lang=js&"
export * from "./HeadSearch.vue?vue&type=script&lang=js&"
import style0 from "./HeadSearch.vue?vue&type=style&index=0&id=03543fa4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03543fa4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/Design/Input.vue').default})
